<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <span class="title">Personal information</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card>
          <form @submit.prevent="formSubmit">
            <v-card-text>
              <v-container fluid grid-list-xl class="ma-0 pa-0">
                <v-layout row wrap>
                  <v-flex xs12 md3>
                    <v-layout row wrap class="text-xs-center">
                      <v-flex xs12>
                        <picture-input 
                        v-if="showImageUploader" 
                        @change="onChanged" 
                        ref="pictureInput" 
                        width="192" 
                        height="192"
                        accept="image/jpeg,image/png, image/gif" 
                        size="10" 
                        name="file"
                        :zIndex="0"
                        :hideChangeButton="true">
                        </picture-input>
                        <v-avatar size="192px" tile v-else>
                          <img :src="imagePath">
                        </v-avatar>
                      </v-flex>
                      <v-flex xs12>
                        <v-btn v-if="!showImageUploader" flat @click.native="showImageUploader = true">
                          change image
                        </v-btn>
                        <v-tooltip top v-if="showImageUploader">
                          <v-btn flat icon color="accent" slot="activator" @click.native="attemptUpload" :disabled="image === '' ? true : false">
                            <v-icon>backup</v-icon>
                          </v-btn>
                          <span>Upload</span>
                        </v-tooltip>

                        <v-tooltip top v-if="showImageUploader">
                          <v-btn flat icon color="error" slot="activator" @click="onCancel()">
                            <v-icon>clear</v-icon>
                          </v-btn>
                          <span>Cancel</span>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 md9>
                    <v-layout row wrap>
                      <v-flex xs12 md6>
                        <v-text-field required label="First name" v-model="user.firstName" v-validate="'required'" :error-messages="errors.collect('first name')"
                          data-vv-name="first name"></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field required label="Last name" v-model="user.lastName" v-validate="'required'" :error-messages="errors.collect('last name')"
                          data-vv-name="last name"></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field required label="Employee ID" v-model="user.employee_id" v-validate="'required'" :error-messages="errors.collect('employee id')"
                          data-vv-name="employee id"></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field required label="E-mail" v-model="user.email" v-validate="'required|email'" :error-messages="errors.collect('email')"
                          data-vv-name="email"></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field required label="Phone" v-model="user.phone" v-validate="'required|numeric'" :error-messages="errors.collect('phone')"
                          data-vv-name="phone" mask="+### ## ### ####"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="default" to="/profile/changepassword">change password</v-btn>
              <v-btn dark color="accent" @click="changeProfile" :loading="getLoading" :disable="getLoading">
                update profile
              </v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-card>
    </v-flex>
    <v-snackbar :color="color" :timeout="timeout" bottom right v-model="snackbar">
      {{ text }}
      <v-btn flat dark @click.native="snackbar = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'
import PictureInput from 'vue-picture-input'
import { httpInstance as axios } from '../../api'

export default {
  name: 'profile-detail',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      user: Object.assign({}, this.$store.state.users.activeUser),
      imagePath: `${axios.defaults.baseURL}${
        this.$store.state.users.activeUser.normal_photo
      }`,
      showImageUploader: false,
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: '',
      image: ''
    }
  },
  components: {
    PictureInput
  },
  computed: {
    ...mapGetters(['getActiveUser', 'getResponse', 'getLoading'])
  },
  methods: {
    ...mapActions(['changeUserProfile', 'uploadPicture']),
    changeProfile: function () {
      this.changeUserProfile(this.user)
        .then(() => {
          let response = this.getResponse
          this.snackbar = true
          this.text =
            response.status === 200
              ? 'Changed successfully.'
              : response.data.message
          this.color = response.status === 200 ? 'success' : 'error'
        })
        .catch(error => {
          console.log(error)
        })
    },

    onChanged (image) {
      if (image) {
        this.image = image
      } else {
        console.log('FileReader API not supported: use the <form>, Luke!')
      }
    },

    onCancel () {
      this.image = ''
      this.showImageUploader = false
    },

    attemptUpload () {
      if (this.image) {
        this.dialog = false
        this.uploadPicture({ name: 'file', file: this.image })
          .then(() => {
            this.imagePath = `${axios.defaults.baseURL}${
              this.$store.state.users.activeUser.normal_photo
            }`
            let response = this.getResponse
            this.showImageUploader = response.status !== 200
            this.snackbar = true
            this.text =
              response.status === 200
                ? 'Changed successfully.'
                : response.data.message
            this.color = response.status === 200 ? 'success' : 'error'
          })
          .catch(error => {
            console.log(error)
          })
      }
    }
  }
}
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/ProfileDetail.vue